export default __webpack_public_path__ + "static/media/Alpha-Group-A-Gigis-Green.de70bd43.png";